/** Textos da tela Início (dashboard). */

export const DASHBOARD_SECTION_TITLE = 'Início';
export const DASHBOARD_SECTION_SUBTITLE = 'Resumo operacional e métricas do negócio.';

export const DASHBOARD_TAB_OVERVIEW = 'Visão geral';
export const DASHBOARD_TAB_METRICS = 'Métricas';
export const DASHBOARD_TABLIST_ARIA_LABEL = 'Abas da seção';

export const DASHBOARD_LOADING = 'Carregando...';

/** KPIs — visão geral */
export const DASHBOARD_KPI_MANUT_TODAY = 'Manutenções essa semana';
export const DASHBOARD_KPI_CONTACTS_OVERDUE = 'Contatos atrasados';
export const DASHBOARD_KPI_REMINDERS_WEEK = 'Lembretes a receber (essa semana)';
export const DASHBOARD_KPI_CONVERSION = 'Taxa de Conversão (%)';
export const DASHBOARD_KPI_REVENUE_MONTH = 'Receita Total';

export const DASHBOARD_TREND_VS_PRIOR_WEEK = 'vs. semana anterior';
export const DASHBOARD_TREND_VS_PRIOR_MONTH = 'vs. mês anterior';

export const DASHBOARD_UPCOMING_LEADS_TITLE = 'Próximos serviços a lembrar';
export const DASHBOARD_UPCOMING_LEADS_EMPTY = 'Nenhuma manutenção prevista à frente.';

export const DASHBOARD_PIPELINE_PENDENTE = 'Pendente';
export const DASHBOARD_PIPELINE_CONTATADO = 'Contatado';
export const DASHBOARD_PIPELINE_AGENDADO = 'Agendado';

export const DASHBOARD_ALERTS_TITLE = 'Alertas';
export const DASHBOARD_ALERTS_EMPTY = 'Sem falhas de envio registradas.';

export const DASHBOARD_CHARTS_MONTH_LABEL = 'Mês';
export const DASHBOARD_CHARTS_BAR_TITLE = 'Movimento no mês';
export const DASHBOARD_CHARTS_BAR_ENVIOS = 'Envios';
export const DASHBOARD_CHARTS_BAR_CONTATOS = 'Contatos';
export const DASHBOARD_CHARTS_BAR_AGEND = 'Agendamentos';

export const DASHBOARD_CHARTS_LINE_TITLE = 'Envios e manutenções por dia';
export const DASHBOARD_CHARTS_LINE_EMPTY = 'Sem dados neste gráfico.';
export const DASHBOARD_CHARTS_LINE_LEGEND_SENDS = 'Envios';
export const DASHBOARD_CHARTS_LINE_LEGEND_MAINT = 'Manutenções';

export const DASHBOARD_CHARTS_REVENUE_TITLE = 'Faturamento do mês';

export const DASHBOARD_CHARTS_EMPTY_MONTH = 'Sem dados neste mês.';

export const DASHBOARD_TOOLTIP_VALUE = 'Quantidade';

export const DASHBOARD_REGISTER_SERVICE_BUTTON = 'Registrar serviço';

/** Agenda da semana (visão geral) */
export const DASHBOARD_AGENDA_TITLE = 'Agenda da semana';
export const DASHBOARD_AGENDA_EMPTY = 'Nada marcado para esta semana.';
export const DASHBOARD_AGENDA_SEND_TITLE = 'Lembrete enviado';
export const DASHBOARD_AGENDA_MAINT_SCHED_TITLE = 'Manutenção agendada';
export const DASHBOARD_AGENDA_MAINT_EXP_TITLE = 'Manutenção prevista';
export const DASHBOARD_AGENDA_BADGE_SENT = 'Enviado';
export const DASHBOARD_AGENDA_BADGE_SCHED = 'Agendada';
export const DASHBOARD_AGENDA_BADGE_EXPECT = 'Prevista';

export const DASHBOARD_AGENDA_SCROLL_PREV = 'Ver dias anteriores';
export const DASHBOARD_AGENDA_SCROLL_NEXT = 'Ver próximos dias';

/** Aba Métricas — visão anual */
export const DASHBOARD_YEAR_SELECT_ARIA = 'Ano das métricas';

/** Rótulos curtos para eixo de meses (gráficos anuais). */
export const DASHBOARD_YEAR_MONTH_SHORT_LABELS = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
] as const;

/** Seg–Dom para distribuição por dia da semana (gráfico anual). */
export const DASHBOARD_YEAR_WEEKDAY_SHORT_LABELS = [
  'Seg',
  'Ter',
  'Qua',
  'Qui',
  'Sex',
  'Sáb',
  'Dom',
] as const;

export const DASHBOARD_YEAR_KPI_TOTAL_REVENUE = 'Receita total do ano';
export const DASHBOARD_YEAR_KPI_AVG_MONTHLY = 'Média mensal';
export const DASHBOARD_YEAR_KPI_AVG_TICKET = 'Ticket médio (manutenções)';
export const DASHBOARD_YEAR_KPI_CONVERSION = 'Taxa de conversão anual';
export const DASHBOARD_YEAR_KPI_TICKET_EMPTY = '—';

export const DASHBOARD_YEAR_CHART_REVENUE = 'Receita por mês';
export const DASHBOARD_YEAR_CHART_SERVICES = 'Serviços registrados por mês';
export const DASHBOARD_YEAR_CHART_FUNNEL = 'Envios, contatos e agendamentos';
export const DASHBOARD_YEAR_CHART_WEEKDAY = 'Distribuição por dia da semana';

export const DASHBOARD_YEAR_LEGEND_SENDS = 'Lembretes recebidos';
export const DASHBOARD_YEAR_LEGEND_CONTACTS = 'Clientes contatados';
export const DASHBOARD_YEAR_LEGEND_SCHEDULED = 'Manutenções agendadas';
export const DASHBOARD_YEAR_LEGEND_WD_CONTACTS = 'Contatos';
export const DASHBOARD_YEAR_LEGEND_WD_SCHEDULED = 'Agendamentos';
